import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "@/i18n";

import "@/validations";

import isAppFeatureEnabled from "@/plugins/AppFeatures";

Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;

Vue.prototype.$isAppFeatureEnabled = isAppFeatureEnabled;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
